// Strips HTML tags from string
export const stripTags = (string) => {
    return string.replace(/(<([^>]+)>)/gi, '');
};

// Remove Value from URL Params
export const removeURLParamValue = (params, key, valueToRemove) => {
    const values = params.getAll(key);
    if (values.length) {
        params.delete(key);
        for (const value of values) {
            if (value !== valueToRemove) {
                params.append(key, value);
            }
        }
    }
    return params;
};

// Scroll to element by ref
export const scrollToRef = (ref) => {
    if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth' });
    }
};

// Get translation
export const __ = (string, replacements) => {
    /* global smart_translations */
    let translatedString = smart_translations?.[string] ?? string;

    if (replacements) {
        Object.keys(replacements).forEach((key) => {
            translatedString = translatedString.replace(`{{${key}}}`, replacements[key]);
        });
    }

    return translatedString;
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();

    // Si le cookie n'est pas trouvé, retourner null
    return null;
};
